import { Typography } from "PFComponents/typography";
import { convertToPercentage } from "PFCore/utilities/math";

type PercentageValueProps = {
  value: number | null;
};

export const PercentageValue = ({ value }: PercentageValueProps) => (
  <Typography withMargin variant="labelBold">
    {convertToPercentage(value)}
  </Typography>
);
